import { action } from "mobx";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { countries } from "@/util/countries";
import type { SxProps, Theme } from "@mui/material";

type CountrySelectProps = {
  selectedCountry?: string;
  size?: "small" | "medium";
  fullWidth?: boolean;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  onChange: (country: string) => void;
  error: boolean;
};

export const CountrySelect = (props: CountrySelectProps) => {
  const { onChange, selectedCountry, size, fullWidth, disabled, sx, } = props;
  const { t } = useTranslation();
  const selected = countries.find(c => c.value === selectedCountry) || null;

  return (
    <Autocomplete
      value={selected}
      options={countries}
      fullWidth={fullWidth}
      disabled={disabled}
      autoHighlight
      size={size || "small"}
      getOptionLabel={option => option.label}
      renderOption={(props, option) => {
        const { key, ...rest } = props;
        return (
          <Box key={key} component="li" sx={{ "& > img": { mr: 2, flexShrink: 0 } }} {...rest}>
            <img loading="lazy" width="20" src={`https://flagcdn.com/w20/${option.value.toLowerCase()}.webp`} alt={option.value} />
            {option.label}
          </Box>
        );
      }}
      renderInput={params => (
        <TextField
          error={props.error}
          label={t("Country")}
          slotProps={{
            htmlInput: {
              ...params.inputProps,
              autoComplete: "new-password", // disable autocomplete and autofill
            },
          }}
          {...params}
        />
      )}
      onChange={action((_, option: CountryType | null) => {
        onChange(option?.value || "");
      })}
      sx={sx}
    />
  );
};

interface CountryType {
  value: string;
  label: string;
}
